// Auto-generado por @xone-web/staticweb v0.13.0 (MPA Island mode).
// Pagina: LoginColl
// NO EDITAR: se regenera en cada build.

import { createAppContext } from "@xone-web/app-orchestrator";
import { registerXoneIsland } from "@xone-web/islands-runtime";
import * as events from "./LoginColl.events";
import * as __functions from "./functions";
import { ROUTE_MAP } from "./routes";
import { APP_CONFIG } from "./app-config";
import { COLL_DEF } from "./LoginColl.colldef";

const api = createAppContext({
    routeMap: ROUTE_MAP,
    apiBase: APP_CONFIG.apiBase,
    tablePrefix: APP_CONFIG.tablePrefix,
    appName: APP_CONFIG.name,
    projectId: APP_CONFIG.projectId,
    collectionName: "LoginColl",
    collectionDefinition: COLL_DEF as unknown as Record<string, unknown>,
});

// Bake entry-point y login collection para navegacion post-login
api.macros.set("ENTRY_POINT", APP_CONFIG.entryPoint);
if (APP_CONFIG.loginCollection) {
    api.macros.set("LOGIN_COLLECTION", APP_CONFIG.loginCollection);
}

// Registrar objetos API XOne como globals en window para que
// functions.js pueda acceder a ui, self, appData, $http, crypto,
// console como variables globales (paridad sandbox XOne).
const __w = window as unknown as Record<string, unknown>;
__w.ui = api.ui;
__w.self = api.self;
__w.This = api.This;
__w.ThisDataColl = api.ThisDataColl;
__w.appData = api.appData;
__w.$http = api.$http;
// window.crypto is read-only (Web Crypto API) — use xoneCrypto alias
Object.defineProperty(__w, "xoneCrypto", { value: api.crypto, configurable: true });
try { Object.defineProperty(__w, "crypto", { value: api.crypto, configurable: true }); } catch { /* read-only in browser */ }
__w.Bundle = api.Bundle;
__w.console = api.console;
__w.user = api.appData.getCurrentUser() ?? {};

// Registrar funciones globales de functions.js en window para que
// los eventos transpilados puedan llamarlas como bare identifiers.
for (const [k, v] of Object.entries(__functions)) {
    if (typeof v === "function") __w[k] = v;
}

registerXoneIsland({ api, events });

const handlers = events as Record<string, ((api: unknown, ...args: unknown[]) => Promise<unknown>) | undefined>;
async function invoke(name: string): Promise<void> {
    const fn = handlers[name];
    if (typeof fn === "function") {
        await fn(api);
    }
}

document.addEventListener("DOMContentLoaded", async () => {
    try {
        await invoke("create");
        await invoke("load");
        await invoke("beforeEdit");
        await invoke("afterEdit");
        // Sync self → DOM: actualizar spans/inputs que muestran valores
        // calculados en los lifecycle events (KPIs, saludos, etc.)
        api.domSync.syncAll();
        // Reset dirty state: lifecycle events set fields on self which
        // triggers dirty tracking, but these are initialization values,
        // not user changes. Mark current state as clean baseline.
        const s = api.self as unknown as { _dirty?: { setOriginal?: (f: Map<string, unknown>) => void; commit?: (f: Map<string, unknown>) => void } };
        if (s._dirty?.setOriginal) {
            s._dirty.setOriginal(new Map(Object.entries(api.self.toJson())));
        }
    } catch (err) {
        console.error("[xone] lifecycle error in LoginColl:", err);
    }
});

// Dirty warning: si self tiene cambios sin guardar, el browser muestra
// dialogo nativo "Leave site? Changes you made may not be saved."
window.addEventListener("beforeunload", (e) => {
    if (typeof api.self.getDirty === "function" && api.self.getDirty()) {
        e.preventDefault();
    }
});

// bfcache pageshow handler ya registrado por createAppContext —
// no duplicar aqui.

if (typeof window !== "undefined") {
    (window as unknown as Record<string, unknown>).__xone = { collection: "LoginColl", api, events };
}
